import React, { useState, useEffect } from "react";
import { apiGetTerimaanByDateRange, apiGetBahagianList } from "../../api/terimaan";
import { generatePrintTerimaanLaporanHtml } from "../../components/STPrint/PrintTerimaanLaporan";
import { Snackbar, Alert } from "@mui/material";
import {  
  Grid,
  Card,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Icon,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Typography,
} from "@mui/material";
// Import your user context/provider here. Adjust as needed.
// Example: import { AuthContext } from "context/AuthContext";
import MDBox from "components/MDBox";
import PrintIcon from "@mui/icons-material/Print";
import MDTypography from "components/MDTypography";
import { pageHeaderStyles } from "utils/pageHeaderStyles";
import { buttonStyles } from "utils/buttonStyles";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import DashboardNavbar from "examples/Navbars/DashboardNavbar";

export default function Laporan() {

  const [snackbarOpen, setSnackbarOpen] = useState(false);
  const [snackbarMsg, setSnackbarMsg] = useState("");
  const [tarikhMula, setTarikhMula] = useState("");
  const [tarikhTamat, setTarikhTamat] = useState("");
  const [bahagianList, setBahagianList] = useState(["SEMUA"]);
  const [bahagian, setBahagian] = useState("");
  const [printing, setPrinting] = useState(false);

  useEffect(() => {
    let mounted = true;
    (async () => {
      try {
        const list = await apiGetBahagianList();
        if (mounted && Array.isArray(list) && list.length) setBahagianList(list);
      } catch (_) { /* silently ignore */ }
    })();
    return () => { mounted = false; };
  }, []);

  return(
    <DashboardLayout>
      <DashboardNavbar />
      <MDBox py={2}>
        <Grid container spacing={2}>
          <Grid item xs={12} md={6}>
            <Card>
              <MDBox
                mx={2}
                mt={-3}
                py={2}
                px={2}
                variant="gradient"
                sx={pageHeaderStyles.report}
                borderRadius="lg"
                coloredShadow="info"
              >
                <MDTypography variant="h6" color="white">
                  Laporan Terimaan Hasil
                </MDTypography>
              </MDBox>
              <MDBox p={1} mt={3}>
                <Grid container spacing={1} justifyContent="center" alignItems="center">
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Tarikh Mula"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      required
                      value={tarikhMula}
                      onChange={e => setTarikhMula(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={6}>
                    <TextField
                      label="Tarikh Tamat"
                      type="date"
                      InputLabelProps={{ shrink: true }}
                      fullWidth
                      size="small"
                      required
                      value={tarikhTamat}
                      onChange={e => setTarikhTamat(e.target.value)}
                    />
                  </Grid>
                  <Grid item xs={12} md={12}>
                    <FormControl
                      fullWidth
                      size="small"
                      sx={{
                    "& .MuiOutlinedInput-root": {
                      backgroundColor: "#ffffffff",
                      fontSize: "0.775rem",
                      p: 1.2,
                    },
                    "& .MuiInputLabel-root": {
                      fontSize: "0.775rem",
                    },
                  }}
                    >
                      <InputLabel>Bahagian</InputLabel>
                      <Select
                        label="Bahagian"
                        value={bahagian}
                        onChange={e => setBahagian(e.target.value)}
                      >
                        {bahagianList.map(b => (
                          <MenuItem key={b} value={b === 'SEMUA' ? 'SEMUA' : b}>{b}</MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </Grid>
                  <Grid item xs={12} md={6} style={{ display: 'flex', justifyContent: 'center' }}>
                    <Button
                      startIcon={<PrintIcon />}
                      size="small"
                      variant="contained"
                      sx={{ ...buttonStyles.primary, mt: 1, mb: 1, px2: 0, minWidth: 0 }}
                      disabled={!tarikhMula || !tarikhTamat || printing}
                      onClick={async () => {
                        try {
                          if (printing) return;
                          setPrinting(true);
                          const selectedBahagian = bahagian && bahagian.trim() !== '' ? bahagian : undefined;
                          const res = await apiGetTerimaanByDateRange(tarikhMula, tarikhTamat, selectedBahagian);
                          const data = res.data || [];
                          if (!data.length) {
                            setSnackbarMsg("Tiada rekod terimaan dijumpai untuk julat tarikh ini.");
                            setSnackbarOpen(true);
                            setPrinting(false);
                            return;
                          }
                          const html = generatePrintTerimaanLaporanHtml({ data, tarikhMula, tarikhTamat, bahagian: selectedBahagian });
                          const printWindow = window.open("", "_blank");
                          printWindow.document.write(html);
                          printWindow.document.close();
                        } catch (err) {
                          setSnackbarMsg("Gagal memuatkan data terimaan untuk cetakan.");
                          setSnackbarOpen(true);
                        } finally {
                          setPrinting(false);
                        }
                      }}
                    >
                      {printing ? 'MENJANA...' : 'CETAK'}
                    </Button>
                  </Grid>
                </Grid>
              </MDBox>
            </Card>
          </Grid>  
        </Grid>
          {/* Snackbar for error messages */}
        <Snackbar open={snackbarOpen} autoHideDuration={4000} onClose={() => setSnackbarOpen(false)} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
          <Alert onClose={() => setSnackbarOpen(false)} severity="error" sx={{ width: '100%' }}>
            {snackbarMsg}
          </Alert>
        </Snackbar>
      </MDBox>
    </DashboardLayout>
  );
}